import { createTheme, ThemeOptions } from '@material-ui/core'

import { adminThemeBreakpoints } from './breakpoints'
import {
  adminLightPlaceholder,
  adminThemeDefaultProps,
  adminThemeStatus,
  adminThemeZIndex,
} from './customThemeProperties'
import { overrides } from './overrides'
import { basePalette, dataVizPalette, popoverPalette } from './palette'
import { adminThemeTypography } from './typography'

export const popoverOptions = {
  themeName: 'Popover',
  palette: {
    ...basePalette,
    ...popoverPalette,
    ...dataVizPalette,
  },
  breakpoints: adminThemeBreakpoints,
  typography: adminThemeTypography,
  overrides: overrides,
  /** Legacy Properties. Avoid new usage. */
  ...adminLightPlaceholder,
  ...adminThemeZIndex,
  ...adminThemeStatus,
  ...adminThemeDefaultProps,
} satisfies ThemeOptions

export const popover = /* @__PURE__ */ createTheme(popoverOptions)
